module.exports = __webpack_public_path__ + "static/media/991930.5f66994d.png";